import React from "react";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";

import { templates } from "@reactivated";

import { AnonOrder } from "../components/AnonOrder";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AnonOrderDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <AnonOrder {...props} />
            <DataLayerPush events={props.ga_events} />
        </PageSkeleton>
    );
};
